module.exports = __webpack_public_path__ + "static/media/elk_dnd_1.e8ecbf74.jpg";